<template>
 
  <div id="app" v-if="!isMobile" style="width: 100vw;height: 100vh;overflow-x: hidden;">
    <LanguageToggle  style="position: absolute;right: 30px;top:30px" @updateLanguage="handleLanguageUpdate"/>
    <div class="topclass"> 
      <div class="topleft">
        <div class="imgphoto">
          <img class="logopng" src="../../public/logo.png" alt="">
          <img v-if="isEnglish" class="fontpng" style="margin-right:20px" src="../../public/enfont.png" alt="" >
          <img v-else class="fontpng" src="../../public/font.png" alt="" >
        </div>
        <div v-if="isEnglish" class="fontdes">
          Specializing in mobile game distribution for both domestic and overseas markets, we offer a one-stop solution coveringproduct selection & evaluation, localized adaptation, and global promotion & operation, empowering developers to achieve dual-track growth in domestic and international markets
        </div>
        <div v-else class="fontdes">
          专注于国内与海外市场的手机游戏发行，提供从产品筛选评估、本地化调优到全球推广运营的一站式解决方案，助力开发者实现国内外双轨增长
        </div>
      </div>
      <div class="topright">
        <img class="rightphoto" src="../../public/1.png" alt="">
      </div>
    </div>

    <div class="yellowdiv">
      <img v-if="isEnglish" src="../../public/engame.png" alt="" style="width: 20vw;margin-top: 80px;">
      <img v-else src="../../public/game.png" alt="" style="width: 20vw;margin-top: 80px;">
      <div v-if="isEnglish" class="midfontdes" style="color:#4d4d4d;    width: 70vw; ">
        Aggregating premium resources and successfully launching blockbuster titles across eight core genres including action, strategy, and competitive gaming, achieving breakthroughs both domestically with high-rated TapTap hits and internationally via Google Play chart-toppers
      </div>
      <div v-else  class="midfontdes" style="color:#4d4d4d;    width: 70vw; ">
          聚合顶尖资源，成功发行涵盖动作、策略、竞技等八大核心赛道的现象级产品，国内TapTap 高分佳作与海外Google Play热门游戏双线突破！
      </div>
      <div class="gamelistlogo">
        <img src="../../public/logo1.png" alt="" class="gamelistlogoinfo">
        <img src="../../public/logo2.png" alt="" class="gamelistlogoinfo">
        <img src="../../public/logo3.png" alt="" class="gamelistlogoinfo">
        <img src="../../public/logo4.png" alt="" class="gamelistlogoinfo">
        <img src="../../public/logo5.png" alt="" class="gamelistlogoinfo">
        <img src="../../public/logo6.png" alt="" class="gamelistlogoinfo">
      </div>
    </div>

     <div class="blackdiv">
        <div style="display: flex;flex-direction: column;">
          <img src="../../public/fire.png" alt="" style="width: 15vw;margin: 1vw;">
          <img v-if="isEnglish" src="../../public/enyibo.png" alt="" style="width: 30vw;">
          <img v-else src="../../public/yibo.png" alt="" style="width: 20vw;">
          <div v-if="isEnglish"  class="midfontdes" style="color:#4d4d4d ;width: 29vw;padding-right: 100px;">
            Unite legendary anime IP characters and original heroes in explosive real-time PVP battles! Master dynamic ‌"Energy Clash" mechanics‌ through swipe-triggered combo skills, unleashing dazzling transformations and ultimate finishing moves.
          </div>
          <div v-else class="midfontdes" style="color:#4d4d4d ;width: 29vw;padding-right: 100px;">
            一款热血卡通格斗手游，集结经典动漫IP角色与原创英雄，主打"动感对波"实时PVP玩法，通过滑动组合技触发变身与必杀特效。
            游戏包含剧情闯关、赛季竞技模式，支持1v1好友对战及60秒快节奏对决，搭配开局即送50抽福利与30+隐藏彩蛋系统，以Q版打击感与策略连招组合为特色
          </div>
        </div>
        <div>
          <img src="../../public/22.png" alt="" style="width: 25vw;">
        </div>
     </div>

      <div class="blackdiv" style="background-color: #292f33;padding-bottom: 0;">
         <div>
          <img src="../../public/23.png" alt="" style="width: 25vw;">
        </div>
       <div style="display: flex;flex-direction: column;    align-items: flex-end;">
         <img src="../../public/fire.png" alt="" style="width: 15vw;margin: 1vw;">
          <img v-if="isEnglish" src="../../public/endongwu.png" alt="" style="width: 30vw;">
          <img v-else src="../../public/dongwu.png" alt="" style="width: 20vw;">
          <div v-if="isEnglish"  class="midfontdes" style="color:#4d4d4d ;width: 27vw;padding-left: 100px;">
            A side-scrolling action mobile game where players embody 8 unique classes, including Panda Swordsman and Fox Gunslinger25, battling through dynamically scaled rogue-lite dungeons with randomized skill synergies
          </div>
          <div v-else class="midfontdes" style="color:#4d4d4d ;width: 27vw;padding-left: 100px;">
            一款横版闯关动作手游，化身熊猫剑士、狐狸枪手等8大职业，通过roguelike随机技能组合挑战动态难度关卡。游戏支持4人联机团本、赛季天梯排位，
            搭载高燃连招特效与无限制转职系统，全球下载量超2000万，首充即送SSR级宠物及百种隐藏成就彩蛋
          </div>
          <div style="display: flex;">
              <img src="../../public/24.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/25.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/26.png" alt="" style="width: 8vw;margin-right: 20px;">
          </div>
        </div>
       
     </div>

    <div class="blackdiv" style="background-color: #292f33;padding-top: 0;">
         <div style="display: flex;flex-direction: column;">
           <img src="../../public/fire.png" alt="" style="width: 15vw;margin: 1vw;">
          <img v-if="isEnglish" src="../../public/enshuishang.png" alt="" style="width: 20vw;">
          <img v-else src="../../public/shuishang.png" alt="" style="width: 20vw;">
          <div v-if="isEnglish"  class="midfontdes" style="color:#4d4d4d ;width: 27vw;padding-right: 100px;">
            A sandbox simulation mobile game where players architect and manage bustling aquatic resorts. Strategically design waterslides, wave pools, and themed zones while optimizing visitor happiness through real-time needs management, facility upkeep, and adaptive weather systems
          </div>
          <div v-else  class="midfontdes" style="color:#4d4d4d ;width: 27vw;padding-right: 100px;">
            一款模拟经营类手游，玩家可自由规划水上乐园布局，建造滑梯、泳池等设施，并通过管理游客需求、设施维护及动态天气系统提升满意度。
            支持多人互动与个性化装饰，融合竞速、闯关等玩法，体验从建设到运营的全流程沉浸式经营乐趣
          </div>
          <div style="display: flex;">
              <img src="../../public/31.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/32.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/33.png" alt="" style="width: 8vw;margin-right: 20px;">
          </div>
        </div>
        <div>
          <img src="../../public/27.png" alt="" style="width: 25vw;">
        </div>
     </div>

     <div class="blackdiv" style=" flex-direction: column;    padding: 80px 18%;">
       <img src="../../public/fire.png" alt="" style="width: 15vw;margin: 1vw;">
        <img v-if="isEnglish"  src="../../public/enzuixin.png" alt="" style="width: 20vw;margin-bottom: 1vw;">
        <img v-else src="../../public/zuixin.png" alt="" style="width: 20vw;margin-bottom: 1vw;">
        <div style="display: flex;justify-content: space-between;color: white;font-size: 16px;font-weight: 600;">
          <div style="display: flex;flex-direction: column;">
            <img src="../../public/34.png" alt="" style="width: 30vw;height: fit-content;">
            <div style="font-size: 24px;margin: 6px 0 ;margin-top: 25px;">2025-04-16</div>
            <div v-if="isEnglish"  style="font-size: 36px;">A Wave Of Superman 2</div><div  v-else style="font-size: 36px;">一波超人2</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;align-items: center;justify-content: space-around;">
            <div> <img src="../../public/35.png" alt="" style="width: 15vw;">
            <div style="margin: 3px 0 ;">2024-03-27</div>
            <div v-if="isEnglish"  style="font-size: 16px;margin-bottom: 10px;">A Wave Of Superman</div><div v-else style="font-size: 16px;margin-bottom: 10px;">一波超人</div></div>

             <div> <img src="../../public/36.png" alt="" style="width: 15vw;">
            <div style="margin: 3px 0 ;">2024-06-12</div>
            <div v-if="isEnglish" style="font-size: 16px;margin-bottom: 10px;">Lingwu World</div> <div v-else style="font-size: 16px;margin-bottom: 10px;">灵武世界</div></div>

             <div> <img src="../../public/37.png" alt="" style="width: 15vw;">
            <div style="margin: 3px 0 ;">2024-08-08</div>
            <div v-if="isEnglish" style="font-size: 16px;">Water Park</div> <div v-else style="font-size: 16px;">水上乐园</div></div>

             <div> <img src="../../public/38.png" alt="" style="width: 15vw;">
            <div style="margin: 3px 0 ;">2024-11-28</div>
            <div v-if="isEnglish" style="font-size: 16px;">The Great League Of Animals</div><div v-else style="font-size: 16px;">动物大联盟</div></div>
          </div>
        </div>
     </div>

    <div class="newblackdiv" style="background-color: #292f33;">
      <div style="display: flex;color:white;justify-content: space-evenly;font-size: 0.75vw;">
         <div  v-if="isEnglish" style="width: 16vw;">&emsp;&emsp;  Specializing in mobile game distribution for both domestic and overseas markets, we offer a one-stop solution coveringproduct selection & evaluation, localized adaptation, and global promotion & operation, empowering developers to achieve dual-track growth in domestic and international markets
      </div>
         <div v-else style="width: 16vw;">&emsp;&emsp;专注于国内与海外市场的手机游戏发行，提供从产品筛选评估、本地化调优到全球推广运营的一站式解决方案，助力开发者实现国内外双轨增长</div>
        
        
         <div style="">
          <div style="display: flex;flex-direction: column;    width: 24vw;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备18144595号-2</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >深圳游点好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>深圳市南山区崇文花园4号办公楼807</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>youdianhaowan.com</div>
            </div>
          </div>
      </div>
      </div>
       
      <div style="border: 0.1px solid #404040;margin: 40px 0;margin-bottom: 20px;"></div>
      <div  v-if="isEnglish" class="bottom">youdianhaowan.com Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
      <div v-else class="bottom">youdianhaowan.com 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
    </div>

  </div>

  <div id="app" v-else style="width: 100vw;overflow-x: hidden;">
   
    <div class="topclass"> 
        <div class="phonetopleft">
          <div style="display:flex;justify-content: space-between;">
            <div></div>
            <LanguageToggle  style="margin-top:15px;margin-right:15px" @updateLanguage="handleLanguageUpdate"/>
          </div>

          <div class="phoneimgphoto">
            <img class="phonelogopng" src="../../public/logo.png" alt="">
            <img v-if="isEnglish" class="phonefontpng" src="../../public/enfont.png" alt="" >
            <img v-else class="phonefontpng" src="../../public/font.png" alt="" >
          </div>
          <div v-if="isEnglish"  class="phonefontdes">
            Specializing in mobile game distribution for both domestic and overseas markets, we offer a one-stop solution coveringproduct selection & evaluation, localized adaptation, and global promotion & operation, empowering developers to achieve dual-track growth in domestic and international markets
          </div>
          <div v-else  class="phonefontdes">
            &emsp;&emsp;专注于国内与海外市场的手机游戏发行，提供从产品筛选评估、本地化调优到全球推广运营的一站式解决方案，助力开发者实现国内外双轨增长
          </div>
           
        </div>
        
      </div>
    <div class="yellowdiv">
      <img   v-if="isEnglish"  src="../../public/engame.png" alt="" style="width:70vw;margin-top: 40px;    margin-bottom: 20px;">
      <img v-else src="../../public/game.png" alt="" style="width:70vw;margin-top: 40px;">
      <div  v-if="isEnglish" class="midfontdes" style="color:#4d4d4d;  padding-top: 10px;padding-bottom: 20px;  width: 71vw; font-size: 14px;">
        &emsp;&emsp;Aggregating premium resources and successfully launching blockbuster titles across eight core genres including action, strategy, and competitive gaming, achieving breakthroughs both domestically with high-rated TapTap hits and internationally via Google Play chart-toppers
       </div>
      <div v-else  class="midfontdes" style="color:#4d4d4d;  padding-top: 10px;padding-bottom: 20px;  width: 71vw; font-size: 14px;">
          &emsp;&emsp;聚合顶尖资源，成功发行涵盖动作、策略、竞技等八大核心赛道的现象级产品，国内TapTap 高分佳作与海外Google Play热门游戏双线突破！
      </div>
      <div class="phonegamelistlogo">
        <img src="../../public/logo1.png" alt="" class="phonegamelistlogoinfo">
        <img src="../../public/logo2.png" alt="" class="phonegamelistlogoinfo">
        <img src="../../public/logo3.png" alt="" class="phonegamelistlogoinfo">
        <img src="../../public/logo4.png" alt="" class="phonegamelistlogoinfo">
        <img src="../../public/logo5.png" alt="" class="phonegamelistlogoinfo">
        <img src="../../public/logo6.png" alt="" class="phonegamelistlogoinfo">
      </div>
    </div>


    <div class="phoneblackdiv">
       <div>
        <img src="../../public/22.png" alt="" style="width: 50vw;">
      </div>
      <div style="display: flex;flex-direction: column;align-items: center;">
        <img src="../../public/fire.png" alt="" style="width: 40vw;margin: 1vw;">
        <img v-if="isEnglish" src="../../public/enyibo.png" alt="" style="width: 65vw;">
        <img v-else src="../../public/yibo.png" alt="" style="width: 45vw;">
        <div  v-if="isEnglish" class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 19px;margin-top: 20px;">
          &emsp;&emsp;Unite legendary anime IP characters and original heroes in explosive real-time PVP battles! Master dynamic ‌"Energy Clash" mechanics‌ through swipe-triggered combo skills, unleashing dazzling transformations and ultimate finishing moves.
        </div>
        <div v-else class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 19px;margin-top: 20px;">
           &emsp;&emsp;一款热血卡通格斗手游，集结经典动漫IP角色与原创英雄，主打"动感对波"实时PVP玩法，通过滑动组合技触发变身与必杀特效。
          游戏包含剧情闯关、赛季竞技模式，支持1v1好友对战及60秒快节奏对决，搭配开局即送50抽福利与30+隐藏彩蛋系统，以Q版打击感与策略连招组合为特色
        </div>
      </div>
     
     </div>

       <div class="phoneblackdiv" style="background-color: #292f33;padding-bottom: 0;">
         <div>
          <img src="../../public/23.png" alt="" style="width: 50vw;">
        </div>
       <div style="display: flex;flex-direction: column;    align-items: center;">
         <img src="../../public/fire.png" alt=""  style="width: 40vw;margin: 1vw;">
          <img v-if="isEnglish" src="../../public/endongwu.png" alt="" style="width: 75vw;">
          <img v-else src="../../public/dongwu.png" alt="" style="width: 45vw;">
          <div v-if="isEnglish"  class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 17px;margin-top: 20px;margin-bottom: 50px;">
            &emsp;&emsp;A side-scrolling action mobile game where players embody 8 unique classes, including Panda Swordsman and Fox Gunslinger25, battling through dynamically scaled rogue-lite dungeons with randomized skill synergies
          </div>
          <div v-else  class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 17px;margin-top: 20px;margin-bottom: 50px;">
            &emsp;&emsp;一款横版闯关动作手游，化身熊猫剑士、狐狸枪手等8大职业，通过roguelike随机技能组合挑战动态难度关卡。游戏支持4人联机团本、赛季天梯排位，
            搭载高燃连招特效与无限制转职系统，全球下载量超2000万，首充即送SSR级宠物及百种隐藏成就彩蛋
          </div>
          <!-- <div style="display: flex;    flex-direction: column;">
              <img src="../../public/24.png" alt="" style="width: 45vw;margin-top: 15px;">
              <img src="../../public/25.png" alt="" style="width: 45vw;margin-top: 10px;">
              <img src="../../public/26.png" alt="" style="width: 45vw;margin-top: 10px;">
          </div> -->
        </div>
       
     </div>

    <div class="phoneblackdiv" style="background-color: #292f33;padding-bottom: 0;">
       <div>
          <img src="../../public/27.png" alt="" style="width: 50vw;">
        </div>
         <div style="display: flex;flex-direction: column;align-items: center;">
           <img src="../../public/fire.png" alt="" style="width: 40vw;margin: 1vw;">
          <img v-if="isEnglish" src="../../public/enshuishang.png" alt="" style="width: 45vw;">
          <img v-else src="../../public/shuishang.png" alt="" style="width: 45vw;">
          <div  v-if="isEnglish"   class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 17px;margin-top: 20px;margin-bottom: 50px;">
            &emsp;&emsp;A sandbox simulation mobile game where players architect and manage bustling aquatic resorts. Strategically design waterslides, wave pools, and themed zones while optimizing visitor happiness through real-time needs management, facility upkeep, and adaptive weather systems
          </div>
          <div  v-else class="phonemidfontdes" style="color:#4d4d4d ;padding: 0 17px;margin-top: 20px;margin-bottom: 50px;">
            &emsp;&emsp;一款模拟经营类手游，玩家可自由规划水上乐园布局，建造滑梯、泳池等设施，并通过管理游客需求、设施维护及动态天气系统提升满意度。
            支持多人互动与个性化装饰，融合竞速、闯关等玩法，体验从建设到运营的全流程沉浸式经营乐趣
          </div>
          <!-- <div style="display: flex;">
              <img src="../../public/31.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/32.png" alt="" style="width: 8vw;margin-right: 20px;">
              <img src="../../public/33.png" alt="" style="width: 8vw;margin-right: 20px;">
          </div> -->
        </div>
     </div>


    <div class="phoneblackdiv" style=" flex-direction: column;    padding: 50px 18%;">
       <img src="../../public/fire.png" alt="" style="width: 45vw;margin: 1vw;">
        <img v-if="isEnglish" src="../../public/enzuixin.png" alt="" style="width: 75vw;margin-bottom: 25px;">
        <img v-else  src="../../public/zuixin.png" alt="" style="width: 45vw;margin-bottom: 15px;">
        <div style="display: flex;justify-content: space-between;color: white;font-size: 16px;font-weight: 600;flex-direction: column;">
          <div style="display: flex;flex-direction: column;">
            <img src="../../public/34.png" alt="" style="width: 55vw;height: fit-content;">
            <div style="margin: 3px 0 ;">2025-04-16</div>
            <div v-if="isEnglish" style="font-size: 16px;margin-bottom: 10px;">A Wave Of Superman 2</div>
            <div v-else style="font-size: 16px;margin-bottom: 10px;">一波超人2</div>
          </div>
                 <div style="display: flex;flex-direction: column;"> <img src="../../public/35.png" alt="" style="width: 55vw;height: fit-content;">
            <div style="margin: 3px 0 ;">2024-03-27</div>
            <div v-if="isEnglish" style="font-size: 16px;margin-bottom: 10px;">A Wave Of Superman</div>
            <div v-else  style="font-size: 16px;margin-bottom: 10px;">一波超人</div></div>

                 <div style="display: flex;flex-direction: column;"> <img src="../../public/36.png" alt="" style="width: 55vw;height: fit-content;">
            <div style="margin: 3px 0 ;">2024-06-12</div>
            <div  v-if="isEnglish"  style="font-size: 16px;margin-bottom: 10px;">Lingwu World</div>
            <div v-else style="font-size: 16px;margin-bottom: 10px;">灵武世界</div></div>

                  <div style="display: flex;flex-direction: column;"> <img src="../../public/37.png" alt="" style="width: 55vw;height: fit-content;">
            <div style="margin: 3px 0 ;">2024-08-08</div>
            <div v-if="isEnglish" style="font-size: 16px;">Water Park</div>
            <div v-else style="font-size: 16px;">水上乐园</div></div>

                  <div style="display: flex;flex-direction: column;"> <img src="../../public/38.png" alt="" style="width: 55vw;height: fit-content;">
            <div style="margin: 3px 0 ;">2024-11-28</div>
            <div v-if="isEnglish" style="font-size: 16px;">The Great League Of Animals</div>
            <div v-else style="font-size: 16px;">动物大联盟</div></div>
        </div>
     </div>


    <div class="phonenewblackdiv" style="background-color: #292f33;">
          <div style="display: flex;flex-direction: column;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备18144595号-2</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish" style="text-align: right;">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >深圳游点好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>深圳市南山区崇文花园4号办公楼807</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>youdianhaowan.com</div>
            </div>
          </div>
       
      <div style="border: 0.1px solid #404040;    margin: 10px 0;"></div>
      <div v-if="isEnglish" class="bottom" style="font-size: 12px;margin-bottom: 20px;"> Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>

      <div v-else class="bottom" style="font-size: 12px;margin-bottom: 20px;"> 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
    </div>


  </div>
</template>

<script>
 import MobileDetect from 'mobile-detect';
import LanguageToggle from './LanguageToggle.vue';
export default {
  name: 'App',
  components: {
    LanguageToggle,
  },
  data() {
    return {
      isMobile: false,
      isEnglish: false,
    };
  },
  mounted() {
    this.detectDevice();
  },
  methods: {
    detectDevice() {
      const md = new MobileDetect(window.navigator.userAgent);
      this.isMobile = md.mobile(); // 或者使用 md.tablet() 来检测平板设备
    },
    handleLanguageUpdate(newLanguage) {
      this.isEnglish = newLanguage
      // 处理语言切换逻辑，例如更新页面内容或调用其他方法
      console.log('Language updated:', newLanguage); 
    }
  }
};
</script>

<style>
.bottom{
    color: #ffffff;
  font-size: 14px;
      display: flex;
    justify-content: center;
}

.blackdiv{
  background: #1a1a1a;
  display: flex;
  padding: 100px 18%;
  justify-content: space-between;
 
}
.phoneblackdiv{
   background: #1a1a1a;
  display: flex;
  padding: 50px 18%;
  justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.newblackdiv{
    background: #1a1a1a;
  padding: 150px 18%;
  padding-bottom: 1vw;

}

.phonenewblackdiv{
    background: #1a1a1a;
  padding: 20px 18%;
  padding-bottom: 1vw;
  font-size: 12px;
  color: white;
}


  .midfontdes{
    font-size: 1.1rem;
    font-weight: 400;
    color: #999999 !important;
    padding: 50px 0  ;
  }
  .phoneidfontdes{
    font-size: 14px;
    font-weight: 400;
    color: #999999 !important;
    /* padding: 50px 0  ; */
  }
 .gamelistlogo{
  display: flex;
  padding-bottom: 100px;
 }
 .gamelistlogoinfo{
 width: 13vw;
 
  margin:15px;
 }
  .phonegamelistlogo{
  display: flex;
  padding-bottom: 60px;
  flex-wrap: wrap;
    width: 70vw;
 }
  .phonegamelistlogoinfo{
 width: 26vw;
 
  margin:15px;
 }
.yellowdiv{
  width: 100%;
  display: flex;
  background: #fac422;
  flex-direction: column;
    align-items: center
}

.rightphoto{
  position: absolute;
    left: 48%;
    top: 15vh;
    width: 50vw;
}
.fontdes{
 font-size: 1.125rem;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 0 15vw;
}

.phonefontdes{
 font-size: 14px;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 50px 15vw;
}


.fontpng{
      width: 25vw
}
.phonefontpng{
      width: 50vw
}
.imgphoto{
  padding: 25vh 20px 0 10vw;
  display: flex;
      justify-content: space-between;
}

.phoneimgphoto{
  padding: 5vh 20px 0 10vw;
  display: flex;
  justify-content: space-around;
}
.logopng{
     width: 10vw;
    height: 100%;
}
.phonelogopng{
     width: 18vw;
    height: 100%;
}
.topclass{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
}
/* 根据需要添加全局样式 */
.topleft{
  background-color: #000000;
    width: 55%;
      height: 100%;
}

.phonetopleft{
  background-color: #000000;
}
.topright{
  background-color: #57bbff;
   width: 45%;
     height: 100%;
}

 

</style>
